<ng-template #template>
  <div class="svc-creator-tab__content svc-translation-tab" [class]="model.isEmpty ? 'svc-translation-tab--empty' : ''">
    <svc-surface-placeholder *ngIf="model.isEmpty" [name]="'translation'"
      [placeholderTitleText]="model.placeholderTitleText"
      [placeholderDescriptionText]="model.placeholderDescriptionText">
    </svc-surface-placeholder>
    <div *ngIf="!model.isEmpty" class="st-content">
      <div class="svc-flex-column st-strings-wrapper">
        <div class="svc-flex-row st-strings-header">
          <survey-content [model]="model.stringsHeaderSurvey"></survey-content>
        </div>
        <div class="svc-flex-row svc-plugin-tab__content st-strings">
          <survey-content [model]="model.stringsSurvey"></survey-content>
        </div>
      </div>
    </div>
  </div>
</ng-template>